const updatePaginationCurrent = (currentPage, totalPages) => {
  const pagination = document.querySelector(".pagination__list");
  if (!pagination) return;

  const templateLink = pagination.querySelector(".pagination__item.link[data-page]");
  const buildPageUrl = (pageNumber) => {
    if (!templateLink) return null;
    const templateUrl = templateLink.getAttribute("href");
    if (!templateUrl) return null;
    if (templateUrl.includes("page=")) {
      return templateUrl.replace(/page=\d+/, `page=${pageNumber}`);
    }
    const separator = templateUrl.includes("?") ? "&" : "?";
    return `${templateUrl}${separator}page=${pageNumber}`;
  };

  const currentItems = pagination.querySelectorAll(".pagination__item--current");
  currentItems.forEach((item) => {
    const pageValue = item.dataset.page;
    const pageNumber = parseInt(pageValue, 10);
    if (item.tagName === "SPAN" && !Number.isNaN(pageNumber)) {
      const newUrl = buildPageUrl(pageNumber);
      if (newUrl) {
        const newLink = document.createElement("a");
        newLink.className = item.className;
        newLink.classList.remove("pagination__item--current");
        newLink.classList.add("link");
        newLink.setAttribute("href", newUrl);
        newLink.dataset.page = pageValue;
        newLink.textContent = item.textContent.trim();
        item.replaceWith(newLink);
        return;
      }
    }

    item.classList.remove("pagination__item--current");
  });

  pagination
    .querySelectorAll("[data-page]")
    .forEach((item) => item.removeAttribute("aria-current"));

  const currentItem = pagination.querySelector(
    `[data-page="${currentPage}"]`
  );
  if (currentItem) {
    currentItem.classList.add("pagination__item--current");
    currentItem.setAttribute("aria-current", "page");
  }

  const prevLink = pagination.querySelector(".pagination__item--prev");
  const nextLink = pagination.querySelector(".pagination__item--next");
  if (prevLink) {
    if (currentPage > 1) {
      const prevUrl = buildPageUrl(currentPage - 1);
      if (prevUrl) prevLink.setAttribute("href", prevUrl);
      prevLink.classList.add("active");
    } else {
      prevLink.classList.remove("active");
    }
  }
  if (nextLink && totalPages) {
    if (currentPage < totalPages) {
      const nextUrl = buildPageUrl(currentPage + 1);
      if (nextUrl) nextLink.setAttribute("href", nextUrl);
      nextLink.classList.add("active");
    } else {
      nextLink.classList.remove("active");
    }
  }
};

const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
      updatePaginationCurrent(currentPage, totalPages);
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      } 
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
